import { getRaw } from "./client";
import type { IncomeExpenseReport } from "../types/report";

/** The all-time income-and-expense report of one client's books. */
export async function getIncomeExpense(clientId: number): Promise<IncomeExpenseReport> {
  return getRaw<IncomeExpenseReport>(`/api/clients/${clientId}/reports/income-expense`);
}
